import styled from 'styled-components';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
export const S = {
    Layout: styled.div `
    display: flex;
    flex-direction: column;

    width: 100%;
    height: ${(props) => `calc(${props.pageHeight}px - 77px)`};
    padding: 30px 30px 0;
    background: ${SEMANTIC_COLORS.DEFAULT_PAGE_BACKGROUND};
  `,
    LayoutTitleDescription: styled.div `
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    flex-shrink: 0;

    width: 100%;
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 26px;
    color: ${SEMANTIC_COLORS.DEFAULT_TITLE};
  `,
    Title: styled.div `
    font-weight: 500;
  `,
    Description: styled.div `
    font-weight: 400;
  `,
    LayoutHospitalSearchSection: styled.div `
    width: 100%;
    margin-top: 20px;
    flex-grow: 1;

    overflow-y: auto;
  `,
    LayoutLabel: styled.div `
    margin-top: 10px;
  `,
    SearchBox: styled.div `
    position: relative;

    display: flex;
    justify-content: space-between;
    width: 100%;
    min-height: 53px;
    padding: 7px 10px;

    text-align: center;

    background: ${SEMANTIC_COLORS.DEFAULT_FIELD_BOX_BACKGROUND};
    border-radius: 10px;
  `,
    SearchBoxInput: styled.input `
    width: 100%;
    height: 100%;
    padding: 8px 5px 8px 12px;

    font-size: 18px;
    color: ${SEMANTIC_COLORS.DEFAULT_TEXT};
    background: ${SEMANTIC_COLORS.DEFAULT_INPUT_BACKGROUND};

    border: none;
    border-radius: 16px 0 0 16px;

    &:focus {
      outline: none;
    }
  `,
    SearchBoxIcon: styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    padding-right: 10px;

    background-color: ${SEMANTIC_COLORS.DEFAULT_ICON};
    border-radius: 0 16px 16px 0;
  `,
    HospitalList: styled.div `
    width: 100%;
    margin: 9px 0 20px;
  `,
    LayoutLoadMoreButton: styled.div `
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 10px 0;
  `,
    LayoutNoResult: styled.div `
    display: grid;
    width: 100%;
    height: 350px;

    background: ${(props) => `no-repeat url(${props.src})`};
    background-position: 0 60px;
    background-size: 250px auto;
  `,
    NoResultFeedbackText: styled.div `
    grid-area: 1/1;

    padding: 7px 18px 0;
    line-height: 23px;

    color: ${SEMANTIC_COLORS.ERROR_TEXT};
  `,
    LayoutFooter: styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    width: 100%;
    height: 100px;
    background: ${SEMANTIC_COLORS.DEFAULT_PAGE_BACKGROUND};
  `,
    GapRow: styled.div `
    width: ${(props) => `${props.width}px`};
  `,
};
